import React, { useContext, useRef, useState } from 'react';
import dayjs from 'dayjs';
import { navigate } from '@reach/router';

import Grid from '@material-ui/core/Grid'
import TextField from '@material-ui/core/TextField'

import { DataGrid } from '@material-ui/data-grid';
import { DbxContext } from '../../../services/DbxContext';
import makeFilters from '../../../app/common/RegexFilters';

const InvoiceList = ({ invoices, invoiceType, onSelectionChange = () => {} }) => {
    const cache = useContext(DbxContext);
    const pageTopic = `InvoicePageSettings${invoiceType}`;
    const sortTopic = `InvoiceSortSettings${invoiceType}`;
    const pageSettings = cache.read(pageTopic) || { page: 0, pageSize: 25 };
    const sortSettings = cache.read(sortTopic) || { sortModel: [] };

    const criteriaTopic = `InvoiceSearchSettings${invoiceType}`;
    const criteria = cache.read(criteriaTopic) || '';
    const criteriaRef = useRef(criteria);
    const [filters, setFilters] = useState(makeFilters(criteria));

    const columns = [
        { field: 'title', headerName: 'Intermediary', width: 200 },
        { field: 'referrer', headerName: 'Referrer', width: 250 },
        { field: 'serviceUserName', headerName: 'Vulnerable Person', width: 250 },
        { field: 'bookingReference', headerName: 'Booking #', width: 150 },
        { field: 'invoiceReference', headerName: 'Invoice #', width: 100 },
        { field: 'courtCaseNumber', headerName: 'Court Case #', width: 150 },
        { field: 'createdDate', headerName: 'Invoice Date', width: 150 },
        { field: 'grandTotal', headerName: 'Amount', width: 150, type: 'number' },
        { field: 'xeroInvoiceId', headerName: 'Xero', width: 30 },
    ];

    const rows = invoices
        .filter(({
            reference,
            intermediary: {
                profile: {
                    title = ''
                } = {}
            } = {},
            client: {
                name: referrer = ''
            } = {},
            referral: {
                bookingReference = ''
            } = {},
            courtCase: {
                courtCaseNumber = '',
                serviceUserName = ''
            } = {},
            timesheet: {
                purchaseOrder = ''
            } = {}
        }) => {

            return filters.every(rx => rx.test(`${reference} ${title} ${referrer} ${bookingReference} ${courtCaseNumber} ${serviceUserName} ${purchaseOrder}`))
        })
        .sort((a, b) => (b.created?.ts || 0) - (a.created?.ts || 0))
        .map(i => {
            if (!i.client || !i.intermediary) console.log('i', i);

            const {
                id = '',
                reference = '',
                _docPath = '',
                xeroInvoiceId = '',
                intermediary: {
                    profile: {
                        title = ''
                    } = {}
                } = {},
                client: {
                    name: referrer = ''
                } = {},
                referral: {
                    bookingReference = ''
                } = {},
                courtCase: {
                    courtCaseNumber = i.timesheet?.courtCase?.courtCaseNumber || '',
                    serviceUserName = ''
                } = {},
                created: {
                    ts = dayjs().valueOf()
                } = {}
            } = i || {};

            return {
                id,
                title,
                referrer,
                bookingReference,
                invoiceReference: reference.toUpperCase(),
                courtCaseNumber,
                serviceUserName,
                createdDate: dayjs(ts).format('YYYY-MM-DD'),
                grandTotal: i.doc.grandTotal(),
                _docPath,
                xeroInvoiceId: xeroInvoiceId && xeroInvoiceId !== '!?' ? '✅' : '⭕'
            };
        });

    const handleRowClick = ({ row }) => {
        navigate(`/${row._docPath}`);
    }

    const handlePageChange = ({ page, pageSize }) => {
        cache.publish({
            topic: pageTopic, value: { page, pageSize }
        })
    }

    const handleSortChange = ({ sortModel }) => {
        cache.publish({ topic: sortTopic, value: { sortModel } });
    }

    const handleCriteriaChange = () => {
        const { value = '' } = criteriaRef.current || {};

        cache.publish({ topic: criteriaTopic, value });
        setFilters(makeFilters(value));
    }

    return (
        <Grid container direction="column" spacing={1}>
            <Grid item xs={12} md={3} style={{ marginBottom: '1rem' }}>
                <TextField
                    id="criteria"
                    label="Search Invoices"
                    inputRef={criteriaRef}
                    defaultValue={criteria}
                    onChange={handleCriteriaChange}
                    fullWidth
                />
            </Grid>
            <Grid item>
                <div style={{ height: 800, width: '100%' }}>
                    <DataGrid
                        rows={rows}
                        columns={columns}
                        disableColumnFilter
                        pageSize={pageSettings.pageSize}
                        page={pageSettings.page}
                        sortModel={sortSettings.sortModel}
                        onRowClick={handleRowClick}
                        onPageSizeChange={handlePageChange}
                        onPageChange={handlePageChange}
                        onSortModelChange={handleSortChange}
                        checkboxSelection
                        onSelectionModelChange={onSelectionChange}
                    />
                </div>
            </Grid>
        </Grid>
    );
};

export default InvoiceList;